module.exports = __webpack_public_path__ + "static/img/Alex-Leapai.88c5625.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Alex-Leapai.jpg
// module id = Os0I
// module chunks = 0